define('viewModels/privileged/qm/ScreenRecordingDetailsView',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (
    ko,
    ViewModel) {
    'use strict';

    var getScreenRecordingUrl = function (url) {
        var parts = url.split('/');
        parts = parts.slice(0, parts.lastIndexOf('interactions') + 2);
        parts.push('screen-recordings');
        return parts.join('/')
            .replace(/admin/, 'quality')
            .replace(/agent/, 'quality');
    };

    return ViewModel.extend(function (url) {
        var self = this;
        self.screenRecordingUrl = ko.observable(getScreenRecordingUrl(url));
    });
});

